import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export type UserPresenceStatus = 'online' | 'away' | 'offline'

const STATUS_SET = new Set<string>(['online', 'away', 'offline'])

export function parseUserPresenceStatus(raw: unknown): UserPresenceStatus | null {
  const value = String(raw ?? '').trim().toLowerCase()
  if (!STATUS_SET.has(value)) return null
  return value as UserPresenceStatus
}

export const useUserPresenceStore = defineStore('userPresence', () => {
  const status = ref<UserPresenceStatus>('online')

  const isOnline = computed(() => status.value === 'online')
  const isAway = computed(() => status.value === 'away')
  const isOffline = computed(() => status.value === 'offline')

  function setStatus(next: UserPresenceStatus): void {
    status.value = next
  }

  function applyStatusRaw(raw: unknown): boolean {
    const parsed = parseUserPresenceStatus(raw)
    if (!parsed) return false
    status.value = parsed
    return true
  }

  function reset(): void {
    status.value = 'online'
  }

  return {
    status,
    isOnline,
    isAway,
    isOffline,
    setStatus,
    applyStatusRaw,
    reset,
  }
})
